import API from "../../../../../global/api";
import jsPDF from "jspdf";
import moment from "moment";
import { isEmpty, sortBy, sumBy } from "lodash";
import { changeDateFormate, handleNoDataVisible, PDFHeader, roundToTwoDecimals } from "../../../../../global/globalFunctions";



export const requestGetReportsHeading = () => {
  return {
    type: "REQUEST_GET_REPORTS_HEADING",
  };
};
export const successGetReportsHeading = (data) => {
  return {
    type: "SUCCESS_GET_REPORTS_HEADING",
    payload: data,
  };
};
export const errorGetReportsHeading = () => {
  return {
    type: "ERROR_GET_REPORTS_HEADING",
  };
};
export const GetReportsHeadingApi = () => {
  return (dispatch) => {
    dispatch(requestGetReportsHeading());
    API.get(`/reports/reports_heading`).then((res) => {
      let data1 = res.data;
      dispatch(successGetReportsHeading(data1));
    }).catch((error) => {
      dispatch(errorGetReportsHeading());
    });
  };
};


export const requestGetDailySaleReport = () => {
  return {
    type: "REQUEST_GET_DAILY_SALE_REPORT",
  };
};
export const successGetDailySaleReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_SALE_REPORT",
    payload: data,
  };
};
export const errorGetDailySaleReport = () => {
  return {
    type: "ERROR_GET_DAILY_SALE_REPORT",
  };
};
export const GetDailySaleReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetDailySaleReport());
    API.post(`/reports/daily_sale_report`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
        dispatch(successGetDailySaleReport(getData.data));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "l";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Daily Sale Report");

        doc.setFont("TimesNewRoman", "bold");
        doc.setFontSize(12);
        doc.text(`Report Date: ${changeDateFormate(payload?.current_date)}`, 20, 125, 0, 20);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);
        const headers = [[
          "S.No",
          "Order No.",
          "Date",
          "Area",
          "Shop",
          "DSF",
          "Sub Total",
          "Discount",
          "Last Balance",
          "Tax",
          "Grand Total",
        ]];
        const data = getData?.data.map((x, i) => [
          i + 1,
          x.number,
          changeDateFormate(x.orderDate),
          x.areaId.areaName,
          x.shopId.shopName,
          x.bookerId.userName,
          x.subTotal,
          x.discount,
          x.shopOldBalance,
          x.taxAmount,
          x.grandTotal,
        ]);
        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        data.push([
          "",
          "TOTAL",
          "",
          "",
          "",
          "",
          sumCol(data, 6),
          sumCol(data, 7),
          sumCol(data, 8),
          sumCol(data, 9),
          sumCol(data, 10),
        ]);

        let content = {
          margin: {
            left: 12,
            right: 15,
          },
          startY: 140,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: "grid",
        };
        doc.autoTable(content);


        doc.setProperties(`Daily Sale Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));

        dispatch(successGetDailySaleReport(getData.data));
      }
    }).catch((error) => {
      dispatch(errorGetDailySaleReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetMonthlySaleReport = () => {
  return {
    type: "REQUEST_GET_MONTHLY_SALE_REPORT",
  };
};
export const successGetMonthlySaleReport = (data) => {
  return {
    type: "SUCCESS_GET_MONTHLY_SALE_REPORT",
    payload: data,
  };
};
export const errorGetMonthlySaleReport = () => {
  return {
    type: "ERROR_GET_MONTHLY_SALE_REPORT",
  };
};
export const GetMonthSaleReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetMonthlySaleReport());
    API.post(`/reports/monthly_sale_report`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "l";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Monthly Sale Report");

        doc.setFont("TimesNewRoman", "bold");
        doc.setFontSize(12);
        doc.text(`Start Date: ${changeDateFormate(payload?.startDate)} `, 20, 125, 0, 20);
        doc.text(`End Date: ${changeDateFormate(payload?.startDate)} `, 20, 140, 0, 20);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);
        const headers = [[
          "S.No",
          "Order No.",
          "Date",
          "Area",
          "Shop",
          "DSF",
          "Sub Total",
          "Discount",
          "Trade Offer",
          "Tax",
          "Grand Total",
        ]];
        const data = getData?.data.map((x, i) => [
          i + 1,
          x.number,
          changeDateFormate(x.orderDate),
          x.areaId.areaName,
          x.shopId.shopName,
          x.bookerId.userName,
          x.subTotal,
          x.discount,
          x.tradeOffer,
          x.taxAmount,
          x.grandTotal,
        ]);
        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        data.push([
          "",
          "TOTAL",
          "",
          "",
          "",
          "",
          sumCol(data, 6),
          sumCol(data, 7),
          sumCol(data, 8),
          sumCol(data, 9),
          sumCol(data, 10)
        ]);

        let content = {
          margin: {
            left: 12,
            right: 15,
          },
          startY: 150,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: "grid",
        };
        doc.autoTable(content);


        doc.setProperties(`Monthly Sale Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetMonthlySaleReport(res.data));
    }).catch((error) => {
      dispatch(errorGetMonthlySaleReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetProductSaleReport = () => {
  return {
    type: "REQUEST_GET_PRODUCT_SALE_REPORT",
  };
};
export const successGetProductSaleReport = (data) => {
  return {
    type: "SUCCESS_GET_PRODUCT_SALE_REPORT",
    payload: data,
  };
};
export const errorGetProductSaleReport = () => {
  return {
    type: "ERROR_GET_PRODUCT_SALE_REPORT",
  };
};
export const GetProductSaleReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetProductSaleReport());
    API.post(`/booking/booking-report-product-wise`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
        dispatch(successGetProductSaleReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Product Sale Report");

        doc.setFont("TimesNewRoman", "bold");
        doc.setFontSize(12);
        doc.text(`Start Date: ${changeDateFormate(payload?.startDate)} `, 20, 125, 0, 20);
        doc.text(`End Date: ${changeDateFormate(payload?.startDate)} `, 20, 140, 0, 20);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);


        const headers = [[
          "Sr",
          "Product Name",
          "Booking Quantity",
          "Liter Quantity",
          "Sale Price",
          // "Total Sale",
          // "Total Purchase",
          "Profit",
        ]];
        const data = getData.data.map((x, i) => [
          i + 1,
          x.productLabel,
          x.quantity,
          Number(x.piecePerBox) * x.quantity,
          x.salePrice,
          // roundToTwoDecimals(x.totalSaleValue),
          // roundToTwoDecimals(x.purchasePriceTotal),
          roundToTwoDecimals(x.totalSaleValue - x.purchasePriceTotal),
        ]);
        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        data.push([
          "",
          "TOTAL",
          "",
          sumCol(data, 3),
          "",
          "",
          "",
          sumCol(data, 7),
        ]);
        let content = {
          margin: {
            left: 12,
            right: 15,
          },
          startY: 150,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: "grid",
        };
        doc.autoTable(content);


        doc.setProperties(`Product Sale Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetProductSaleReport(getData));
    }).catch((error) => {
      dispatch(errorGetProductSaleReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetSpecificProductSaleReport = () => {
  return {
    type: "REQUEST_GET_SPECIFIC_PRODUCT_SALE_REPORT",
  };
};
export const successGetSpecificProductSaleReport = (data) => {
  return {
    type: "SUCCESS_GET_SPECIFIC_PRODUCT_SALE_REPORT",
    payload: data,
  };
};
export const errorGetSpecificProductSaleReport = () => {
  return {
    type: "ERROR_GET_SPECIFIC_PRODUCT_SALE_REPORT",
  };
};
export const GetSpecificProductSaleReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetSpecificProductSaleReport());
    API.post(`/booking/booking-report-product-wise`, payload).then((res) => {
      let getData = res.data.data.filter(item => String(item.product) === String(payload.product));
      if (isEmpty(getData)) {
        handleNoDataVisible()
        dispatch(successGetSpecificProductSaleReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Specific Product Sale Report");

        doc.setFont("TimesNewRoman", "bold");
        doc.setFontSize(12);
        doc.text(`Start Date: ${changeDateFormate(payload?.startDate)} `, 20, 125, 0, 20);
        doc.text(`End Date: ${changeDateFormate(payload?.startDate)} `, 20, 140, 0, 20);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);


        const headers = [[
          "Sr",
          "Product Name",
          "Booking Quantity",
          "Liter Quantity",
          "Sale Price",
          // "Total Sale",
          // "Total Purchase",
          "Profit",
        ]];
        const data = getData.map((x, i) => [
          i + 1,
          x.productLabel,
          x.quantity,
          Number(x.piecePerBox) * x.quantity,
          x.salePrice,
          // roundToTwoDecimals(x.totalSaleValue),
          // roundToTwoDecimals(x.purchasePriceTotal),
          roundToTwoDecimals(x.totalSaleValue - x.purchasePriceTotal),
        ]);
        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        data.push([
          "",
          "TOTAL",
          "",
          sumCol(data, 3),
          "",
          "",
          "",
          sumCol(data, 7),
        ]);
        let content = {
          margin: {
            left: 12,
            right: 15,
          },
          startY: 150,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: "grid",
        };
        doc.autoTable(content);


        doc.setProperties(`Specific Product Sale Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetSpecificProductSaleReport(getData));
    }).catch((error) => {
      dispatch(errorGetSpecificProductSaleReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetBadDebtsReport = () => {
  return {
    type: "REQUEST_GET_BAD_DEBTS_REPORT",
  };
};
export const successGetBadDebtsReport = (data) => {
  return {
    type: "SUCCESS_GET_BAD_DEBTS_REPORT",
    payload: data,
  };
};
export const errorGetBadDebtsReport = () => {
  return {
    type: "ERROR_GET_BAD_DEBTS_REPORT",
  };
};
export const GetBadDebtsReportApi = (showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetBadDebtsReport());
    API.post(`/reports/bad-debts-report`).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
        dispatch(successGetBadDebtsReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "l";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Bad Debts Report");

        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);

        const headers = [[
          "Sr",
          "Shop Name",
          'Shop Closing Balance'
        ]];
        const data = getData.data.map((x, i) => [
          i + 1,
          x.levelFourName,
          `${x.closing_balance} - ${x.closing_balance_sign === 2 ? 'Debit' : 'Credit'}`,
        ]);
        let content = {
          margin: {
            left: 12,
            right: 35,
          },
          startY: 120,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: 'grid',
        };
        doc.autoTable(content);


        doc.setProperties(`Product Sale Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetBadDebtsReport(getData));
    }).catch((error) => {
      dispatch(errorGetBadDebtsReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetAreaRecoveryReport = () => {
  return {
    type: "REQUEST_GET_AREA_RECOVERY_REPORT",
  };
};
export const successGetAreaRecoveryReport = (data) => {
  return {
    type: "SUCCESS_GET_AREA_RECOVERY_REPORT",
    payload: data,
  };
};
export const errorGetAreaRecoveryReport = () => {
  return {
    type: "ERROR_GET_AREA_RECOVERY_REPORT",
  };
};
export const GetAreaRecoveryReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetAreaRecoveryReport());
    API.post(`/reports/area-recovery-report`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
        dispatch(successGetAreaRecoveryReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Area Recovery Report");

        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);
        doc.text(`Area Name: ${payload?.areaName} `, 20, 120, 0, 20);

        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        const headers = [[
          "Sr",
          "Shop Name",
          'Closing Balance',
          'Closing Balance Sign',
          'Receiving Amount',
        ]];
        const data = getData.data.map((x, i) => [
          i + 1,
          x.levelFourName,
          x.closing_balance,
          x.closing_balance_sign === 2 ? 'Debit' : x.closing_balance_sign === 1 ? 'Credit' : '',
        ]);
        data.push([
          "",
          "TOTAL",
          sumCol(data, 2),
        ]);
        let content = {
          margin: {
            left: 12,
            right: 35,
          },
          startY: 130,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: 'grid',
        };
        doc.autoTable(content);


        doc.setProperties(`Area Recovery Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetAreaRecoveryReport(getData));
    }).catch((error) => {
      dispatch(errorGetAreaRecoveryReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetPurchaseProductReport = () => {
  return {
    type: "REQUEST_GET_PURCHASE_PRODUCT_REPORT",
  };
};
export const successGetPurchaseProductReport = (data) => {
  return {
    type: "SUCCESS_GET_PURCHASE_PRODUCT_REPORT",
    payload: data,
  };
};
export const errorGetPurchaseProductReport = () => {
  return {
    type: "ERROR_GET_PURCHASE_PRODUCT_REPORT",
  };
};
export const GetPurchaseProductReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetAreaRecoveryReport());
    API.post(`/receiving/receiving_with_vendor`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
        dispatch(successGetAreaRecoveryReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Purchase Product Report");

        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);
        doc.text(`Start Date: ${changeDateFormate(payload?.startDate)} `, 20, 120, 0, 20);
        doc.text(`End Date: ${changeDateFormate(payload?.startDate)} `, 20, 135, 0, 20);
        doc.text(`Vendor Name: ${payload?.vendorName} `, 20, 150, 0, 20);

        const headers = [[
          "Sr",
          "Product Name",
          'Purchased Quantity',
          'Purchase Price',
          'Total Purchased Value',
        ]];
        const data = getData.data.map((x, i) => [
          i + 1,
          x.productName,
          x.requiredProductQuantity,
          x.productPrice,
          x.totalPurchaseValue,
        ]);
        let content = {
          margin: {
            left: 12,
            right: 35,
          },
          startY: 160,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: 'grid',
        };
        doc.autoTable(content);


        doc.setProperties(`Purchase Product Report ${moment().format("DD-MM-YYYY")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetAreaRecoveryReport(getData));
    }).catch((error) => {
      dispatch(errorGetAreaRecoveryReport());
      showErrorAlert(error.response.data.message);
    });
  };
};


export const requestGetSKUReport = () => {
  return { type: "REQUEST_GET_SKU_REPORT" };
};
export const successGetSKUReport = (data) => {
  return { type: "SUCCESS_GET_SKU_REPORT", payload: data };
};
export const errorGetSKUReport = () => {
  return { type: "ERROR_GET_SKU_REPORT" };
};
export const GetSKUReportApi = (payload, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestGetSKUReport());
    API.post(`/reports/sku_report`, payload).then((res) => {
      const getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible();
        dispatch(successGetSKUReport(getData));
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "l";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "SKU Report");

        doc.setFont("TimesNewRoman", "bold");
        doc.setFontSize(12);
        doc.text(`Start Date: ${changeDateFormate(payload?.startDate)}`, 20, 125, 0, 20);
        doc.text(`End Date: ${changeDateFormate(payload?.endDate)}`, 20, 140, 0, 20);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);

        const headers = [[
          "Sr",
          "Product Name",
          "Sale Qty",
          // "Purchase Qty",
          "Avg Sale Price",
          "Avg Purchase Price",
          "Total Sale Price",
          "Total Purchase Price",
          "Margin",
          "Margin %",
        ]];

        const data = getData.data.map((x, i) => [
          i + 1,
          x.productName,
          x.saleQty,
          // x.purchaseQty,
          x.avgSalePrice,
          x.avgPurchasePrice,
          x.totalSalePrice,
          x.totalPurchasePrice,
          x.margin,
          `${x.marginPercentage ?? 0}%`,
        ]);

        const sumCol = (arr, index) => arr.reduce((a, r) => a + Number(r[index] || 0), 0).toFixed(2);
        data.push([
          "",
          "TOTAL",
          sumCol(data, 2),
          // sumCol(data, 3),
          "",
          "",
          sumCol(data, 5),
          sumCol(data, 6),
          sumCol(data, 7),
          "",
        ]);

        doc.autoTable({
          margin: { left: 12, right: 15 },
          startY: 155,
          styles: { fontSize: 9, lineColor: [0, 0, 0], lineWidth: 0.2 },
          head: headers,
          body: data,
          theme: "grid",
        });

        doc.setProperties(`SKU Report ${moment().format("DD-MM-YYYY")}`);
        const blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));

        dispatch(successGetSKUReport(getData));
      }
    }).catch((error) => {
      dispatch(errorGetSKUReport());
      showErrorAlert(error?.response?.data?.message || "Something went wrong");
    });
  };
};


































export const requestGetDailyDiscountReport = () => {
  return {
    type: "REQUEST_GET_DAILY_DISCOUNT",
  };
};
export const successGetDailyDiscountReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_DISCOUNT",
    payload: data,
  };
};
export const errorGetDailyDiscountReport = () => {
  return {
    type: "ERROR_GET_DAILY_DISCOUNT",
  };
};
export const getDateWiseDiscountReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetDailyDiscountReport());
    API.post(`/reports/daily_discount_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "potrait"; // portrait or landscape
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        //  doc.setFontSize(13);
        //  //doc.setFont('TimesNewRoman', 'Normal')
        const title = "Daily Discount Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const logo1 = getData.restaurantImage;
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 200, 120);
        doc.setFontSize(11);
        doc.setFont("TimesNewRoman", "Normal");
        let yAxis = 150;
        for (let i = 0; i < getData.data.length; i++) {
          const Date1 = getData.data[i].dayOpen.createdAt;
          const restaurant = getData.data[i].dayOpen.restaurant.restaurantName;
          const cashinhand = getData.data[i].dayOpen.cashInHand;
          const closecash = getData.data[i].dayOpen.closingCash;
          const todaysOrderAmount = getData.data[i].dayOpen.todaysDiscountAmount;
          const todaysOrderLength = getData.data[i].dayOpen.todaysDiscountOrderLength;
          const dayopenname = getData.data[i].dayOpen.user.firstName;
          const status = getData.data[i].dayOpen.status;
          const headers = [
            [
              "Sr",
              "Date",
              "Order No.",
              "Sub Total",
              "Discount",
              "Tax",
              "Grand Total",
            ],
          ];
          const data = getData.data[i].orders.map((elt, index) => [
            index + 1,
            moment(elt.createdAt).format("YYYY-MM-DD"),
            elt.number,
            elt.subTotal,
            elt.discount,
            elt.tax,
            elt.grandTotal,
          ]);
          let content = {
            startY: yAxis + 80,
            startX: 10,
            head: headers,
            body: data,
          };
          doc.text(`Day Open Name: ${dayopenname}`, marginLeft, yAxis, 0, 20);
          doc.text(`Status: ${status}`, 350, yAxis, 0, 20);
          doc.text(`Date: ${moment(Date1).format("YYYY-MM-DD")}`, marginLeft, yAxis + 20, 0, 20);
          doc.text(`Restaurant Name: ${restaurant}`, 350, yAxis + 20, 0, 20);
          doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, yAxis + 40, 0, 20);
          doc.text(`Closing Cash: ${closecash}`, 350, yAxis + 40, 0, 20);
          doc.text(`Today Discount Amount: ${todaysOrderAmount}`, marginLeft, yAxis + 60, 0, 20);
          // doc.text(`Today Order Length: ${todaysOrderLength}`, 350, yAxis+60, 0, 20);
          doc.autoTable(content);
          yAxis = doc.lastAutoTable.finalY + 40;
          //doc.addPage();
        }
        doc.setProperties({ title: `Daily Discount Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Daily Discount Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetDailyDiscountReport(getData));
    }).catch((error) => {
      dispatch(errorGetDailyDiscountReport());
      handleDangerVisible();
    });
  };
};


export const requestGetDailyInvoiceReport = () => {
  return {
    type: "REQUEST_GET_DAILY_INVOICE",
  };
};
export const successGetDailyInvoiceReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_INVOICE",
    payload: data,
  };
};
export const errorGetDailyInvoiceReport = () => {
  return {
    type: "ERROR_GET_DAILY_INVOICE",
  };
};
export const getDateWiseInvoiceReport = (data) => {
  return (dispatch) => {
    dispatch(requestGetDailyInvoiceReport());
    API.post(`/reports/daily_discount_report`, data).then((res) => {
      dispatch(successGetDailyInvoiceReport(res.data));
    }).catch((error) => {
      dispatch(errorGetDailyInvoiceReport());
    });
  };
};


export const requestGetDailyOrderBilledReport = () => {
  return {
    type: "REQUEST_GET_DAILY_ORDER_BILLED",
  };
};
export const successGetDailyOrderBilledReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_ORDER_BILLED",
    payload: data,
  };
};
export const errorGetDailyOrderBilledReport = () => {
  return {
    type: "ERROR_GET_DAILY_ORDER_BILLED",
  };
};
export const getDateWiseOrderBilledReport = (data) => {
  return (dispatch) => {
    dispatch(requestGetDailyOrderBilledReport());
    API.post(`/reports/daily_discount_report`, data).then((res) => {
      dispatch(successGetDailyOrderBilledReport(res.data));
    }).catch((error) => {
      dispatch(errorGetDailyOrderBilledReport());
    });
  };
};


export const requestGetDailyOrderCancelReport = () => {
  return {
    type: "REQUEST_GET_DAILY_ORDER_CANCEL",
  };
};
export const successGetDailyOrderCancelReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_ORDER_CANCEL",
    payload: data,
  };
};
export const errorGetDailyOrderCancelReport = () => {
  return {
    type: "ERROR_GET_DAILY_ORDER_CANCEL",
  };
};
export const getDateWiseOrderCancelReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetDailyOrderCancelReport());
    API.post(`/reports/daily_order_cancel_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "potrait"; // portrait or landscape
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        //  doc.setFontSize(13);
        //  //doc.setFont('TimesNewRoman', 'Normal')
        const title = "Daily Order cancel Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const logo1 = getData.restaurantImage;
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 200, 120);
        doc.setFontSize(11);
        doc.setFont("TimesNewRoman", "Normal");
        let yAxis = 150;
        for (let i = 0; i < getData.data.length; i++) {
          const Date1 = getData.data[i].dayOpen.createdAt;
          const restaurant = getData.data[i].dayOpen.restaurant.restaurantName;
          const cashinhand = getData.data[i].dayOpen.cashInHand;
          const closecash = getData.data[i].dayOpen.closingCash;
          const todaysOrderAmount =
            getData.data[i].dayOpen.todaysCancelledAmount;
          const todaysOrderLength =
            getData.data[i].dayOpen.todaysCancelledOrderLength;
          const dayopenname = getData.data[i].dayOpen.user.firstName;
          const status = getData.data[i].dayOpen.status;
          const headers = [
            [
              "Sr",
              "Date",
              "Order No.",
              "Sub Total",
              "Discount",
              "Tax",
              "Grand Total",
            ],
          ];
          const data = getData.data[i].orders.map((elt, index) => [
            index + 1,
            moment(elt.createdAt).format("YYYY-MM-DD"),
            elt.number,
            elt.subTotal,
            elt.discount,
            elt.tax,
            elt.grandTotal,
          ]);
          let content = {
            startY: yAxis + 100,
            startX: 10,
            head: headers,
            body: data,
          };
          doc.text(`Day Open Name: ${dayopenname}`, marginLeft, yAxis, 0, 20);
          doc.text(`Status: ${status}`, 350, yAxis, 0, 20);
          doc.text(`Date: ${moment(Date1).format("YYYY-MM-DD")}`, marginLeft, yAxis + 20, 0, 20);
          doc.text(`Restaurant Name: ${restaurant}`, 350, yAxis + 20, 0, 20);
          doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, yAxis + 40, 0, 20);
          doc.text(`Closing Cash: ${closecash}`, 350, yAxis + 40, 0, 20);
          doc.text(`Today Cancel Order Amount: ${todaysOrderAmount}`, marginLeft, yAxis + 60, 0, 20);
          doc.text(`Today Cancel Order Length: ${todaysOrderLength}`, 350, yAxis + 60, 0, 20);
          doc.autoTable(content);
          yAxis = doc.lastAutoTable.finalY + 20;
          //doc.addPage();
        }
        doc.setProperties({ title: `Daily Order cancel Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Daily Order cancel Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetDailyOrderCancelReport(res.data));
    }).catch((error) => {
      dispatch(errorGetDailyOrderCancelReport());
      handleDangerVisible();
    });
  };
};


export const requestGetDailyPromoReport = () => {
  return {
    type: "REQUEST_GET_DAILY_PROMO",
  };
};
export const successGetDailyPromoReport = (data) => {
  return {
    type: "SUCCESS_GET_DAILY_PROMO",
    payload: data,
  };
};
export const errorGetDailyPromoReport = () => {
  return {
    type: "ERROR_GET_DAILY_PROMO",
  };
};
export const getDailyPromoReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetDailyPromoReport());
    API.post(`/reports/daily_promo_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "potrait"; // portrait or landscape
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        //  doc.setFontSize(13);
        //  //doc.setFont('TimesNewRoman', 'Normal')
        const title = "Daily Promo Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const logo1 = getData.data[0].dayOpen.restaurant.image;
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 215, 120);
        doc.setFontSize(11);
        doc.setFont("TimesNewRoman", "Normal");
        let yAxis = 150;
        for (let i = 0; i < getData.data.length; i++) {
          const Date1 = getData.data[i].dayOpen.createdAt;
          const restaurant = getData.data[i].dayOpen.restaurant.restaurantName;
          const cashinhand = getData.data[i].dayOpen.cashInHand;
          const closecash = getData.data[i].dayOpen.closingCash;
          // const todaysOrderAmount = getData.data[i].dayOpen.todaysOrderAmount;
          // const todaysOrderLength= getData.data[i].dayOpen.todaysOrderLength;
          const dayopenname = getData.data[i].dayOpen.user.firstName;
          const status = getData.data[i].dayOpen.status;
          const headers = [
            [
              "Sr",
              "Date",
              "Order Number",
              "Coupon Name",
              "Coupon Type",
              "Coupon Amount",
            ],
          ];
          const data = getData.data[i].orders.map((elt, index) => [
            index + 1,
            moment(elt.createdAt).format("YYYY-MM-DD"),
            elt.number,
            elt.coupon.name,
            elt.coupon.type,
            elt.discount,
          ]);
          let content = {
            startY: yAxis + 70,
            startX: 10,
            head: isEmpty(getData.data[i].orders) ? "" : headers,
            body: data,
          };
          doc.text(`Day Open Name: ${dayopenname}`, marginLeft, yAxis, 0, 20);
          doc.text(`Status: ${status}`, 350, yAxis, 0, 20);
          doc.text(`Date: ${moment(Date1).format("YYYY-MM-DD")}`, marginLeft, yAxis + 20, 0, 20);
          doc.text(`Restaurant Name: ${restaurant}`, 350, yAxis + 20, 0, 20);
          doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, yAxis + 40, 0, 20);
          doc.text(`Closing Cash: ${closecash}`, 350, yAxis + 40, 0, 20);
          //  doc.text(`Today Order Amount: ${todaysOrderAmount}`, marginLeft, yAxis+60, 0, 20);
          //  doc.text(`Today Order Length: ${todaysOrderLength}`, 350, yAxis+60, 0, 20);
          doc.autoTable(content);
          yAxis = doc.lastAutoTable.finalY + 40;
          //doc.addPage();
        }
        doc.setProperties({ title: `Daily Promo Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Daily Promo Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetDailyPromoReport(getData));
    }).catch((error) => {
      dispatch(errorGetDailyPromoReport());
      handleDangerVisible();
    });
  };
};


// MONTHLY REPORTING



export const requestGetMonthlyDiscountReport = () => {
  return {
    type: "REQUEST_GET_MONTHLY_DISCOUNT",
  };
};
export const successGetMonthlyDiscountReport = (data) => {
  return {
    type: "SUCCESS_GET_MONTHLY_DISCOUNT",
    payload: data,
  };
};
export const errorGetMonthlyDiscountReport = () => {
  return {
    type: "ERROR_GET_MONTHLY_DISCOUNT",
  };
};
export const getMonthWiseDiscountReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetMonthlyDiscountReport());
    API.post(`/reports/monthly_discount_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "potrait"; // portrait or landscape
        const logo1 = getData.restaurantImage;
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        const title = "Discount Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const Date1 = getData.startDate;
        const Date2 = getData.endDate;
        const restaurant = getData.data[0].restaurant.restaurantName;
        const cashinhand = getData.totalCashInHand;
        const closecash = getData.totalClosingCash;
        const todaysOrderAmount = getData.totalDiscountAmount;
        const todaysOrderLength = getData.totalDiscountOrderLength;
        const headers = [
          [
            "Sr",
            "Day Open Date",
            "Day Open Name",
            "Cash In Hand",
            "Closing Cash",
            "Discount Amount",
            "No of Discount Orders",
          ],
        ];
        const data = getData.data.map((elt, index) => [
          index + 1,
          moment(elt.dayOpenDate).format("YYYY-MM-DD"),
          elt.user.firstName,
          elt.cashInHand,
          elt.closingCash,
          elt.todaysDiscountAmount,
          elt.todaysDiscountOrderLength,
        ]);
        let content = {
          startY: 220,
          startX: 10,
          head: headers,
          body: data,
        };
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        // doc.text(`Day Open Name: ${dayopenname}`, marginLeft, 150, 0, 20);
        //doc.text(`Status: ${status}`, 350, 150, 0, 20);
        doc.text(`Restaurant Name: ${restaurant}`, marginLeft, 170, 0, 20);
        //  doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, 190, 0, 20);
        //  doc.text(`Closing Cash: ${closecash}`, 350, 190, 0, 20);
        doc.text(`Total Discount Amount: ${todaysOrderAmount}`, marginLeft, 190, 0, 20);
        doc.text(`Total Discount Length: ${todaysOrderLength}`, 350, 190, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 215, 120);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(`Date From: ${moment(Date1).format("YYYY-MM-DD")} to ${moment(Date2).format("YYYY-MM-DD")}`, 185, 140);
        doc.setFontSize(11);
        doc.autoTable(content);
        doc.setProperties({ title: `Date Wise Discount Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Date Wise Discount Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetMonthlyDiscountReport(res.data));
    }).catch((error) => {
      dispatch(errorGetMonthlyDiscountReport());
      handleDangerVisible();
    });
  };
};


export const requestGetMonthlyOrderCancelReport = () => {
  return {
    type: "REQUEST_GET_MONTHLY_ORDER_CANCEL",
  };
};
export const successGetMonthlyOrderCancelReport = (data) => {
  return {
    type: "SUCCESS_GET_MONTHLY_ORDER_CANCEL",
    payload: data,
  };
};
export const errorGetMonthlyOrderCancelReport = () => {
  return {
    type: "ERROR_GET_MONTHLY_ORDER_CANCELT",
  };
};
export const getMonthWiseOrderCancelReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetMonthlyOrderCancelReport());
    API.post(`/reports/monthly_order_cancel_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        const title = "Order Cancel Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const Date1 = getData.startDate;
        const Date2 = getData.endDate;
        const restaurant = getData.data[0].restaurant.restaurantName;
        const cashinhand = getData.data[0].cashInHand;
        const closecash = getData.data[0].closingCash;
        const todaysOrderAmount = getData.totalCanceledOrderAmount;
        const todaysOrderLength = getData.totalCanceledOrderLength;
        const logo1 = getData.restaurantImage;
        const headers = [
          [
            "Sr",
            "Day Open Date",
            "Day Open Name",
            "Cash In Hand",
            "Closing Cash",
            "Order Cancel Amount",
            "No of Order Cancel",
          ],
        ];
        const data = getData.data.map((elt, index) => [
          index + 1,
          moment(elt.dayOpenDate).format("YYYY-MM-DD"),
          elt.user.firstName,
          elt.cashInHand,
          elt.closingCash,
          elt.todaysCancelledAmount,
          elt.todaysCancelledOrderLength,
        ]);
        let content = {
          startY: 240,
          startX: 10,
          head: headers,
          body: data,
        };
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        // doc.text(`Day Open Name: ${dayopenname}`, marginLeft, 150, 0, 20);
        //doc.text(`Status: ${status}`, 350, 150, 0, 20);
        doc.text(`Restaurant Name: ${restaurant}`, marginLeft, 170, 0, 20);
        // doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, 190, 0, 20);
        // doc.text(`Closing Cash: ${closecash}`, 350, 190, 0, 20);
        doc.text(`Total Cancel Order Amount: ${todaysOrderAmount}`, marginLeft, 190, 0, 20);
        doc.text(`Total Cancel Order Length: ${todaysOrderLength}`, 350, 190, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 215, 120);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(`Date From: ${moment(Date1).format("YYYY-MM-DD")} to ${moment(Date2).format("YYYY-MM-DD")}`, 185, 140);
        doc.setFontSize(11);
        doc.autoTable(content);
        doc.setProperties({ title: `Date Wise Order Cancel Report ${moment().format("YYYY-MM-DD")}.pdf`, });
        //  doc.output('dataurlnewwindow')
        // doc.save(`Date Wise Order Cancel Report ${moment().format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetMonthlyOrderCancelReport(res.data));
    }).catch((error) => {
      dispatch(errorGetMonthlyOrderCancelReport());
      handleDangerVisible();
    });
  };
};


export const requestGetMonthlyPromoReport = () => {
  return {
    type: "REQUEST_GET_MONTHLY_PROMO",
  };
};
export const successGetMonthlyPromoReport = (data) => {
  return {
    type: "SUCCESS_GET_MONTHLY_PROMO",
    payload: data,
  };
};
export const errorGetMonthlyPromoReport = () => {
  return {
    type: "ERROR_GET_MONTHLY_PROMO",
  };
};
export const getMonthWisePromoReport = (data, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetMonthlyPromoReport());
    API.post(`/reports/monthly_promo_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        const title = "Promo Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const Date1 = getData.startDate;
        const Date2 = getData.endDate;
        // const restaurant = getData.data[0].restaurant.restaurantName;
        //const cashinhand = getData.totalCashInHand;
        //const closecash = getData.totalClosingCash;
        const todaysOrderAmount = getData.couponDiscountAmount;
        const todaysOrderLength = getData.couponDiscountLength;
        const logo1 = getData.restaurantImage;
        const headers = [
          ["Order Number", "Order Amount", "Promo Amount", "Order Status"],
        ];
        const data = getData.data.map((elt) => [
          elt.number,
          elt.grandTotal,
          elt.discount,
          elt.status,
        ]);
        let content = {
          startY: 190,
          startX: 10,
          head: headers,
          body: data,
        };
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        // doc.text(`Day Open Name: ${dayopenname}`, marginLeft, 150, 0, 20);
        //doc.text(`Status: ${status}`, 350, 150, 0, 20);
        // doc.text(`Restaurant Name: ${restaurant}`, marginLeft, 170, 0, 20);
        //  doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, 190, 0, 20);
        //  doc.text(`Closing Cash: ${closecash}`, 350, 190, 0, 20);
        doc.text(`Total Promo Amount: ${todaysOrderAmount}`, marginLeft, 160, 0, 20);
        doc.text(`Total Promo Length: ${todaysOrderLength}`, 350, 160, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 215, 120);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(`Date From: ${moment(Date1).format("YYYY-MM-DD")} to ${moment(Date2).format("YYYY-MM-DD")}`, 185, 140);
        doc.setFontSize(11);
        doc.autoTable(content);
        doc.setProperties({ title: `Date Wise Promo Report ${moment().format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Date Wise Promo Report ${moment().format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetMonthlyPromoReport(res.data));
    }).catch((error) => {
      dispatch(errorGetMonthlyPromoReport());
      handleDangerVisible();
    });
  };
};





export const requestGetOrderPrintReport = () => {
  return {
    type: "REQUEST_GET_ORDER_PRINT",
  };
};
export const successGetOrderPrintReport = (data) => {
  return {
    type: "SUCCESS_GET_ORDER_PRINT",
    payload: data,
  };
};
export const errorGetOrderPrintReport = () => {
  return {
    type: "ERROR_GET_ORDER_PRINT",
  };
};
export const GetOrderPdfReportApi = (orderId) => {
  return (dispatch) => {
    dispatch(requestGetOrderPrintReport());
    API.get(`/orders/order_pdf/${orderId}`).then((res) => {
      const getData = res.data.reprintOrderResult;
      if (isEmpty(getData)) {
        handleNoDataVisible();
      } else {
        const doc = new jsPDF("p", "pt", "a4");
        const title = "Order Reprint";
        PDFHeader(doc, title);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(`Order Number: ${getData?.number}`, 40, 120);
        doc.text(`Customer Name: ${getData?.customer?.name}`, 40, 135);
        doc.text(`Date: ${moment(getData?.orderDate).format("DD-MM-YYYY")}`, 40, 150);
        doc.text(`Status: ${getData?.status}`, 40, 165);
        doc.text(`Order Type: ${getData?.orderType}`, 40, 180);

        // ====== TABLE ======
        const tableColumn = ["Sr#", "Product", "Sale Price", "Qty", "Amount"];
        const tableRows = getData.items.map((item, index) => [
          index + 1,
          item.productLabel,
          item.productSellingPrice,
          item.quantity,
          item.productTotalAmount.toLocaleString(),
        ]);

        let subTotal = sumBy(getData?.items, "productTotalAmount");
        let discount = getData?.discount || 0;
        let tax = getData?.tax || 0;
        let grandTotal = getData?.grandTotal;

        // Create main items table
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 200,
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 5,
            lineColor: [220, 220, 220],
            lineWidth: 0.5,
          },
          headStyles: {
            fillColor: [245, 245, 245],
            textColor: [0, 0, 0],
            fontStyle: "bold",
          },
          bodyStyles: {
            textColor: [0, 0, 0],
          },
        });

        // ====== TOTAL SECTION ======
        const finalY = doc.lastAutoTable.finalY + 5;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        const boxX = 360;
        const lineHeight = 17;

        doc.text("Sub Total:", boxX, finalY + lineHeight);
        doc.text(subTotal.toLocaleString(), boxX + 150, finalY + lineHeight, { align: "right" });
        doc.text("Discount:", boxX, finalY + lineHeight * 2);
        doc.text(discount.toLocaleString(), boxX + 150, finalY + lineHeight * 2, { align: "right" });
        doc.text("Tax:", boxX, finalY + lineHeight * 3);
        doc.text(tax.toLocaleString(), boxX + 150, finalY + lineHeight * 3, { align: "right" });
        doc.setTextColor(33, 111, 219);
        doc.text("Grand Total:", boxX, finalY + lineHeight * 4);
        doc.text(grandTotal.toLocaleString(), boxX + 150, finalY + lineHeight * 4, { align: "right" });


        doc.setProperties({ title: `Order Report ${moment().format("DD-MM-YYYY")}`, });
        const blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successGetOrderPrintReport(getData));
    }).catch((error) => {
      console.log(error, "error");
      dispatch(errorGetOrderPrintReport());
    });
  };
};
export const getOrderPrintReport = (id) => {
  return (dispatch) => {
    dispatch(requestGetOrderPrintReport());
    API.get(`/orders/reprint_order/${id}`).then((res) => {
      let getData = res.data;
      dispatch(successGetOrderPrintReport(getData));
    }).catch((error) => {
      dispatch(errorGetOrderPrintReport());
    });
  };
};



export const requestHotSellingReport = () => {
  return {
    type: "REQUEST_HOT_SELLING_REPORT",
  };
};
export const successHotSellingReport = (data) => {
  return {
    type: "SUCCESS_HOT_SELLING_REPORT",
    payload: data,
  };
};
export const errorHotSellingReport = () => {
  return {
    type: "ERROR_HOT_SELLING_REPORT",
  };
};
export const getHotSellingReport = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestHotSellingReport());
    API.post(`/reports/all_Products_report`, data).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.data)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        const title = "Hot Selling Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        const logo1 = getData.restaurantImage;
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 200, 120);
        doc.setFontSize(11);
        doc.setFont("TimesNewRoman", "Normal");
        // doc.text(`Date From: ${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`, 200,140);
        let yAxis = 150;
        for (let i = 0; i < getData.data.length; i++) {
          const Date1 = getData.data[i].dayOpen.dayOpenDate;
          const restaurant = getData.data[i].dayOpen.restaurant.restaurantName;
          const cashinhand = getData.data[i].dayOpen.cashInHand;
          const closecash = getData.data[i].dayOpen.closingCash;
          // const todaysOrderAmount = getData.data[i].dayOpen.todaysDiscountAmount;
          // const todaysOrderLength= getData.data[i].dayOpen.todaysDiscountOrderLength;
          const dayopenname = getData.data[i].dayOpen.user.firstName;
          const status = getData.data[i].dayOpen.status;
          const headers = [
            ["Sr", "Product Name", "Product Quantity", "UOM Name"],
          ];
          const data1 = sortBy(getData.data[i].ProductData, "quantity").reverse();
          const data = data1.map((elt, index) => [
            index + 1,
            elt.productLabel,
            elt.quantity,
            elt.uomLabel,
          ]);
          let content = {
            startY: yAxis + 80,
            startX: 10,
            head: headers,
            body: data,
          };
          doc.text(`Day Open Name: ${dayopenname}`, marginLeft, yAxis, 0, 20);
          doc.text(`Status: ${status}`, 350, yAxis, 0, 20);
          doc.text(`Date: ${moment(Date1).format("YYYY-MM-DD")}`, marginLeft, yAxis + 20, 0, 20);
          doc.text(`Restaurant Name: ${restaurant}`, 350, yAxis + 20, 0, 20);
          doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, yAxis + 40, 0, 20);
          doc.text(`Closing Cash: ${closecash}`, 350, yAxis + 40, 0, 20);
          // doc.text(`Today Discount Amount: ${todaysOrderAmount}`, marginLeft, yAxis+60, 0, 20);
          // doc.text(`Today Order Length: ${todaysOrderLength}`, 350, yAxis+60, 0, 20);
          doc.autoTable(content);
          yAxis = doc.lastAutoTable.finalY + 40;
          //doc.addPage();
        }
        doc.setProperties({ title: `Hot Selling Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Hot Selling Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
      }
      dispatch(successHotSellingReport(res.data));
      // handleVisible();
    }).catch((error) => {
      dispatch(errorHotSellingReport());
      handleDangerVisible();
    });
  };
};


export const requestGetDayOpenReport = () => {
  return {
    type: "REQUEST_GET_DAY_OPEN_REPORT",
  };
};
export const successGetDayOpenReport = (data) => {
  return {
    type: "SUCCESS_GET_DAY_OPEN_REPORT",
    payload: data,
  };
};
export const errorGetDayOpenReport = () => {
  return {
    type: "ERROR_GET_DAY_OPEN_REPORT",
  };
};
export const getDayOpenReport = (data) => {
  return (dispatch) => {
    dispatch(requestGetDayOpenReport());
    API.post(`/dayOpen/dayOpen_record`, data).then((res) => {
      dispatch(successGetDayOpenReport(res.data));
    }).catch((error) => {
      dispatch(errorGetDayOpenReport());
    });
  };
};


export const requestGetDayOpenSaleReport = () => {
  return {
    type: "REQUEST_GET_DAY_OPEN_SALE",
  };
};
export const successGetDayOpenSaleReport = (data) => {
  return {
    type: "SUCCESS_GET_DAY_OPEN_SALE",
    payload: data,
  };
};
export const errorGetDayOpenSaleReport = () => {
  return {
    type: "ERROR_GET_DAY_OPEN_SALE",
  };
};
export const getDayOpenSaleReport = (handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestGetDayOpenSaleReport());
    API.get(`/reports/sale_report_without_dayopen`)
      .then((res) => {
        let getData = res.data;
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        const title = "Day Open Sale Report";
        const companyName = `${getData.resImage.restaurantName}`;
        const companyAddress = `${getData.resImage.restaurantLocation}`;
        const companyNtn = `${getData.resImage.ntn}`;
        // const Date1 = getData.startDate;
        // const Date2 = getData.endDate;
        // const restaurant = getData.data[0].restaurant.restaurantName;
        // const cashinhand = getData.totalCashInHand;
        // const closecash = getData.totalClosingCash;
        const todaysOrderAmount = getData.data[0].orderTotal;
        const todaysOrderLength = getData.data[0].orderLength;
        const logo1 = getData.restaurantImage;
        const headers = [
          [
            "Sr",
            "Product Name",
            "Quantity",
            "Pricce"
          ],
        ];
        const data = getData.data[0].ProductData.map((elt, index) => [
          index + 1,
          elt.productLabel,
          elt.quantity,
          elt.productSellingPrice * elt.quantity
        ]);
        let content = {
          startY: 200,
          startX: 10,
          head: headers,
          body: data,
        };
        doc.addImage(logo1, "PNG", 40, 15, 100, 100);
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text(companyName, 150, 50, 0, 20);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.text(companyAddress, 150, 70, 0, 20);
        doc.text(companyNtn, 150, 90, 0, 20);
        // doc.text(`Day Open Name: ${dayopenname}`, marginLeft, 150, 0, 20);
        //doc.text(`Status: ${status}`, 350, 150, 0, 20);
        // doc.text(`Restaurant Name: ${restaurant}`, marginLeft, 170, 0, 20);
        // doc.text(`Cash In Hand: ${cashinhand}`, marginLeft, 190, 0, 20);
        // doc.text(`Closing Cash: ${closecash}`, 350, 190, 0, 20);
        doc.text(`Total Order Amount: ${todaysOrderAmount}`, marginLeft, 180, 0, 20);
        doc.text(`No Of Orders: ${todaysOrderLength}`, 350, 180, 0, 20);
        doc.setFontSize(18);
        doc.setFont("TimesNewRoman", "bold");
        doc.text(title, 215, 120);
        doc.setFontSize(13);
        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(11);
        doc.autoTable(content);
        doc.setProperties({ title: `Day Open Sale Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`, });
        // doc.output("dataurlnewwindow");
        // doc.save(`Day Open Sale Report ${moment(new Date()).format("YYYY-MM-DD")}.pdf`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
        dispatch(successGetDayOpenSaleReport(getData));
      }).catch((error) => {
        dispatch(errorGetDayOpenSaleReport());
        handleDangerVisible();
      });
  };
};
